import { FichaPlantillaModalForm } from "./FichaPlantillaModalForm"


const FichaPlantillaModalFormWrapper = () => {
    return (<FichaPlantillaModalForm />)
}

export {FichaPlantillaModalFormWrapper}